import * as Types from "../constants/RoleModule";


export const resetRoleModule = () => ({
    type: Types.RESET_ROLE_MODULE,
});

// FETCH ROLES ACTIONS
export const fetchRoleModules = (roleId) => ({
    type: Types.FETCH_ROLE_MODULES,
    payload: roleId
});

export const fetchRoleModulesOk = (roleModules) => ({
    type: Types.FETCH_ROLE_MODULES_OK,
    payload: roleModules
})

export const fetchRoleModulesFailed = (error) => ({
    type: Types.FETCH_ROLE_MODULES_FAILED,
    payload: error
})

// FETCH ROLE PERMISSIONS
export const fetchRolePermissions = (module) => ({
    type: Types.FETCH_ROLE_PERMISSIONS,
    payload: module
});

export const fetchRolePermissionsOk = (roleModule) => ({
    type: Types.FETCH_ROLE_PERMISSIONS_OK,
    payload: roleModule
})

export const fetchRolePermissionsFailed = (error) => ({
    type: Types.FETCH_ROLE_PERMISSIONS_FAILED,
    payload: error
})

// ATTACH MODULE ACTIONS
export const attachModule = (roleModule) => ({
    type: Types.ATTACH_MODULE,
    payload: roleModule
});

export const attachModuleOk = (roleModule) => ({
    type: Types.ATTACH_MODULE_OK,
    payload: roleModule
});

export const attachModuleFailed = (error) => ({
    type: Types.ATTACH_MODULE_FAILED,
    payload: error
});